import { Component } from '@angular/core';

@Component({
    selector: 'app-account-locked',
    templateUrl: './account-locked.component.html',
    styleUrls: ['./account-locked.component.scss'],
    standalone: false
})
export class AccountLockedComponent {
}
